import useGetApi from 'src/api/useGetApi';

export interface CustomerLocationDTO {
  id: string;
  name: string | null;
  dunsNumber?: string | null;
  address: string | null;
  longitude: number | null;
  latitude: number | null;
  disabled: boolean;
}

interface GetCustomerLocationsResponse {
  locations: CustomerLocationDTO[];
}

interface UseCustomerLocationsOptions {
  activeOnly?: boolean;
  canShipTo?: boolean;
  /**
   * Location to return even when the filters above would exclude it — pass the
   * picker's current selection so a filtered list can never blank out a value
   * the record already holds.
   */
  includeLocationId?: string;
}

const useCustomerLocations = (
  customerId: string,
  enabled = true,
  options?: UseCustomerLocationsOptions,
) => {
  const params = new URLSearchParams();
  if (options?.activeOnly) params.append('activeOnly', 'true');
  // Tri-state: `false` is a meaningful filter (non-ship-to locations only), so
  // it must be forwarded rather than treated as "no filter".
  if (options?.canShipTo !== undefined)
    params.append('canShipTo', String(options.canShipTo));
  if (options?.includeLocationId)
    params.append('includeLocationId', options.includeLocationId);
  const queryString = params.toString() ? `?${params.toString()}` : '';

  return useGetApi<GetCustomerLocationsResponse>({
    endpoint: `accounts-receivable/customers/${customerId}/locations${queryString}`,
    options: {
      enabled: enabled && !!customerId,
    },
  });
};

export default useCustomerLocations;
